import React, { useState, useEffect } from 'react'
import AdminTitle from '../AdminTitle'
import { useParams, Link } from 'react-router-dom';
import axios from 'axios'
import DOMPurify from 'dompurify';

type Information = {
  title: string,
  body: string
}

export default function InformationShow() {
  const [information, setInformation] = useState<Information>({
    title: '',
    body: '',
  })

  // 現在のページのidを取得
  const query = useParams().id

  // APIからデータを取得
  useEffect(() => {
    axios.get(`/api/v1/informations/${query}`)
    .then (res =>{
      setInformation({
        title: res.data.information.title,
        body: DOMPurify.sanitize(res.data.information.body),
      })
    })
    .catch (err => {
      console.log(err);
      alert("データの取得に失敗しました。")
    });
  }, [query])

  return (
    <>
      <AdminTitle title={'お知らせ詳細'} />
      <div className='admin-bg__color'>
        <div className='breadcrumb'>
          <ul>
            <li><a href='/admins/informations'>お知らせ一覧</a></li>
            <li>{information.title}</li>
          </ul>
        </div>
        <div className='admin-card'>
          <div className='admin-card__container'>
            <div className="d-flex justify-content-end">
              <Link to={`/admins/informations/${query}/edit`} className='btn admin-show__btn-edit'>
                <span className='material-symbols-outlined'>edit</span>
                編集
              </Link>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>タイトル</div>
              </div>
              <div className='admin-show__group--value'>{information.title}</div>
            </div>
            <div className='admin-show__group'>
              <div className='admin-show__group--label'>
                <div className='admin-show__group--label-letter'>本文</div>
              </div>
              {/* HTMLタグがそのまま表示されないようdangerouslySetInnerHTMLメソッド利用 */}
              <div dangerouslySetInnerHTML={{ __html: information.body }} className='admin-show__group--value' />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
